module.exports = __webpack_public_path__ + "static/media/16-12.453785ac.mp3";